import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Fragment, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Skeleton,
  Typography,
} from '@mui/material';
import FormTextField from '../FormTextField/FormTextField';
import classes from './style';
import { LoadingButton } from '@mui/lab';
import api from '../../services/apiClient';
import Image from 'mui-image';
import { genderRange } from '../../controllers/DetailParticipants';
import { toCurrencyForm } from '../../utils/stringFormatter';

const DetailVirtualParticipants = ({
  eventId,
  addOns,
  showDialog,
  closeDialog,
  goToSummary,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [checkUserStatusLoad, setCheckUserStatusLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState();

  const [email, setEmail] = useState({});
  const [participants, setParticipants] = useState([]);
  const [formattedAddons, setFormattedAddons] = useState([]);

  useEffect(() => {
    if (!showDialog) return;
    setEmail({
      email: {
        value: '',
        errorMessage: '',
      },
    });

    setParticipants([
      {
        firstName: { value: '', errorMessage: '' },
        lastName: { value: '', errorMessage: '' },
        username: { value: '', errorMessage: '' },
        phoneNumber: { value: '', errorMessage: '' },
        gender: { value: '', errorMessage: '' },
        birthDate: { value: '', errorMessage: '' },
        size: { value: '', errorMessage: '' },
        street: { value: '', errorMessage: '' },
        area: { value: '', errorMessage: '' },
        suburb: { value: '', errorMessage: '' },
        city: { value: '', errorMessage: '' },
        province: { value: '', errorMessage: '' },
        postalCode: { value: '', errorMessage: '' },
        jenisAnjing: { value: '', errorMessage: '' },
      },
    ]);

    // console.log(addOns);
    if (addOns.length > 0) {
      const updated = addOns.map((ad) => {
        return {
          ...ad,
          selected: false,
          addonType: ad.sizeOpts?.length > 0 ? 'jersey' : 'other',
          selectedSize: {
            errorMessage: '',
            value: '',
          },
        };
      });

      setFormattedAddons(updated);
    }

    setCurrentPage(0);
  }, [showDialog]);

  const checkUserStatus = async () => {
    // try {
    //   setCheckLimitLoad(true);
    //   const { data } = await api.post('/events/user/check', {
    //     eventId,
    //     email: email?.email?.value,
    //   });

    //   console.log(data);
    // } catch (error) {}

    return false;
  };

  const isDataValid = async () => {
    let isDataValid = true;
    let errMsg = 'Something Wrong, Please check your form.';

    if (currentPage === 0) {
      const updated = { ...email };
      if (email.email?.value === '') {
        updated.email.errorMessage = 'Email is required!';

        setEmail(updated);
        isDataValid = false;
      } else {
        const isEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
          email.email?.value
        );
        if (!isEmail) {
          updated.email.errorMessage = 'Email is not valid!';

          setEmail(updated);
          isDataValid = false;
        }
      }
    }

    if (currentPage === 1) {
      const updated = [...participants];
      updated.forEach((p) => {
        if (p.firstName?.value === '') {
          p.firstName.errorMessage = 'First Name is required!';
          isDataValid = false;
        }

        if (p.lastName?.value === '') {
          p.lastName.errorMessage = 'Last Name is required!';
          isDataValid = false;
        }

        if (p.phoneNumber?.value === '') {
          p.phoneNumber.errorMessage = 'Phone Number is required!';
          isDataValid = false;
        }

        if (p.gender?.value === '') {
          p.gender.errorMessage = 'Gender is required!';
          isDataValid = false;
        }

        if (p.birthDate?.value === '') {
          p.birthDate.errorMessage = 'Birth Date is required!';
          isDataValid = false;
        }

        // if (p.size?.value === '') {
        //   p.size.errorMessage = 'Size is required!';
        //   isDataValid = false;
        // }

        if (p.street?.value === '') {
          p.street.errorMessage = 'Jalan is required!';
          isDataValid = false;
        }

        if (p.area?.value === '') {
          p.area.errorMessage = 'Kelurahan is required!';
          isDataValid = false;
        }

        if (p.suburb?.value === '') {
          p.suburb.errorMessage = 'Kecamatan is required!';
          isDataValid = false;
        }

        if (p.city?.value === '') {
          p.city.errorMessage = 'Kota is required!';
          isDataValid = false;
        }

        if (p.province?.value === '') {
          p.province.errorMessage = 'Provinsi is required!';
          isDataValid = false;
        }

        if (p.postalCode?.value === '') {
          p.postalCode.errorMessage = 'Kode Pos is required!';
          isDataValid = false;
        }

        // if (p.jenisAnjing?.value === '') {
        //   p.jenisAnjing.errorMessage = 'Jenis Anjing is required!';
        //   isDataValid = false;
        // }
      });
      setParticipants(updated);
    }

    if (currentPage === 2) {
      if (formattedAddons.length > 0) {
        const updated = [...formattedAddons].map((fad) => {
          // console.log(fad.name);
          // console.log(fad.selected);
          // console.log(fad.addonType);
          // console.log(fad.selectedSize);
          if (
            fad.selected &&
            fad.addonType === 'jersey' &&
            fad.selectedSize.value === ''
          ) {
            fad.selectedSize.errorMessage = 'addOn size is required!';
            isDataValid = false;
          }

          return fad;
        });

        setFormattedAddons(updated);
      }
    }

    return { valid: isDataValid, errMsg };
  };

  const handleEmailChange = (value, key) => {
    const updated = { ...email };
    if (!!updated[key]?.errorMessage) updated[key].errorMessage = '';
    updated[key].value = value;
    setEmail(updated);
  };

  const handleAddonChange = (idx) => {
    // console.log(idx);
    const updated = [...formattedAddons];
    updated[idx].selected = !updated[idx].selected;

    setFormattedAddons(updated);
  };

  const handleAddonSizeChange = (idx, size) => {
    // console.log(size);
    const updated = [...formattedAddons];
    updated[idx].selectedSize.errorMessage = '';
    updated[idx].selectedSize.value = size;

    setFormattedAddons(updated);
  };

  const handleDataChange = (value, key) => {
    const updatedDP = [...participants];

    if (!!updatedDP[0][key]?.errorMessage) updatedDP[0][key].errorMessage = '';

    updatedDP[0][key].value = value;
    setParticipants(updatedDP);
  };

  const handleCloseDialog = () => {
    // setTeamName({
    //   value: '',
    //   errorMessage: '',
    // });

    // setEmergency({
    //   person: { value: '', errorMessage: '' },
    //   contact: { value: '', errorMessage: '' },
    //   relation: { value: '', errorMessage: '' },
    // });

    // const list = getInitialParticipantState(
    //   { firstName: 'hartz', lastName: 'Lie' },
    //   false,
    //   0,
    //   2,
    //   0,
    //   '1,7',
    //   '1,7'
    // );
    // setParticipants(list);

    closeDialog();
  };

  const handleBack = () => {
    if (currentPage === 3) return setCurrentPage(2);

    if (currentPage === 0) return handleCloseDialog();

    setCurrentPage((prev) => prev - 1);
  };

  const handleNext = async () => {
    const { valid, errMsg } = await isDataValid();
    if (valid === false) return alert(errMsg);

    if (currentPage === 0) {
      const isAlrdUser = await checkUserStatus();

      return setCurrentPage(1);
    }

    if (currentPage === 3) {
      return goToSummary({
        email,
        participants,
        addons: formattedAddons,
        // emergency,
      });
    }
    setCurrentPage((prev) => prev + 1);
  };

  const getButtonBackText = () => {
    if (currentPage === 0) return 'Close';

    return 'Back';
  };

  const getButtonNextText = () => {
    if (currentPage === 3) return 'Summary';

    return 'Next';
  };

  return (
    <Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={showDialog}
        aria-labelledby="responsive-dialog-title"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: !fullScreen ? '768px' : '100%', // Set your width here
            },
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title">
          {'Add Runner Data'}
        </DialogTitle>

        <DialogContent>
          {currentPage === 0 && (
            <Grid container style={classes.containerSpaceAround}>
              <Grid item xs={12} sm={6}>
                <DialogContentText align="center">Email</DialogContentText>
                <Box
                  component={'form'}
                  noValidate
                  autoComplete="off"
                  sx={{ m: 1 }}
                >
                  {/* email */}
                  <FormTextField
                    index={40}
                    i={0}
                    required
                    label={'Email'}
                    errorMessage={email?.email?.errorMessage}
                    value={email?.email?.value}
                    onChange={(e) =>
                      handleEmailChange(e.target?.value, 'email')
                    }
                  />
                  <Typography
                    variant="subtitle2"
                    color={'CaptionText'}
                    sx={{ marginTop: '-10px', marginBottom: '20px' }}
                  >
                    Pastikan Alamat Email ditulis dengan benar, untuk menerima
                    Email Konfirmasi Pembayaran. 1 alamat email hanya untuk 1
                    peserta.
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          )}

          {/* user data daftar */}
          {currentPage === 1 && (
            <Grid container style={classes.containerSpaceAround}>
              {participants.map((p, idx) => (
                <Grid item xs={12} sm={6}>
                  <DialogContentText align="center">Runner</DialogContentText>
                  <Box
                    component={'form'}
                    noValidate
                    autoComplete="off"
                    sx={{ m: 1 }}
                  >
                    {/* first_name */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'First Name'}
                      errorMessage={p.firstName?.errorMessage}
                      value={p.firstName?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'firstName')
                      }
                    />

                    {/* last_name */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Last Name'}
                      errorMessage={p.lastName?.errorMessage}
                      value={p.lastName?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'lastName')
                      }
                    />
                    {/* username */}
                    {/* <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Username'}
                      errorMessage={p.username?.errorMessage}
                      value={p.username?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'username')
                      }
                    /> */}
                    {/* phoneNumber */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Phone Number'}
                      errorMessage={p.phoneNumber?.errorMessage}
                      value={p.phoneNumber?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'phoneNumber')
                      }
                    />
                    {/* gender */}
                    <FormTextField
                      index={1}
                      i={idx}
                      required
                      type={'select'}
                      label={'Gender'}
                      selectOpts={genderRange}
                      errorMessage={p.gender?.errorMessage}
                      value={p.gender?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'gender')
                      }
                    />
                    {/* birthDate */}
                    <FormTextField
                      index={5}
                      i={idx}
                      required
                      type={'date'}
                      label={'Birth Date'}
                      errorMessage={p.birthDate?.errorMessage}
                      value={p.birthDate?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'birthDate')
                      }
                    />
                    {/* size */}
                    {/* <FormTextField
                      index={9}
                      i={idx}
                      required
                      type={'select'}
                      label={'Size'}
                      selectOpts={p?.sizeOpts}
                      errorMessage={p.size?.errorMessage}
                      value={p.size?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'size', idx)
                      }
                    /> */}
                    {/* street */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Jalan (alamat)'}
                      errorMessage={p.street?.errorMessage}
                      value={p.street?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'street')
                      }
                    />
                    {/* area */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Kelurahan (alamat)'}
                      errorMessage={p.area?.errorMessage}
                      value={p.area?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'area')
                      }
                    />
                    {/* suburb */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Kecamatan (alamat)'}
                      errorMessage={p.suburb?.errorMessage}
                      value={p.suburb?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'suburb')
                      }
                    />
                    {/* city */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Kota (alamat)'}
                      errorMessage={p.city?.errorMessage}
                      value={p.city?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'city')
                      }
                    />
                    {/* province */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Provinsi (alamat)'}
                      errorMessage={p.province?.errorMessage}
                      value={p.province?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'province')
                      }
                    />
                    {/* postalCode */}
                    <FormTextField
                      index={0}
                      // i={idx}
                      required
                      label={'Kode Pos (alamat)'}
                      errorMessage={p.postalCode?.errorMessage}
                      value={p.postalCode?.value}
                      onChange={(e) =>
                        handleDataChange(e.target?.value, 'postalCode')
                      }
                    />
                    {/* jenisAnjing */}
                    {eventId === 71 && (
                      <FormTextField
                        index={0}
                        // i={idx}
                        label={'Jenis Anjing (Optional)'}
                        errorMessage={p.jenisAnjing?.errorMessage}
                        value={p.jenisAnjing?.value}
                        onChange={(e) =>
                          handleDataChange(e.target?.value, 'jenisAnjing')
                        }
                      />
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}

          {currentPage === 2 && (
            <Box>
              <Typography variant="h4">AddOns</Typography>
              {formattedAddons?.length > 0 &&
                formattedAddons.map((ad, idx) => (
                  <Box
                    display={ad.price >= 0 ? 'flex' : 'none'}
                    flexDirection={'row'}
                  >
                    <Box>
                      <Checkbox
                        onChange={() => handleAddonChange(idx)}
                        checked={ad.selected}
                      />
                    </Box>
                    <Box display={'flex'} flexDirection={'row'}>
                      <Box
                        sx={{
                          height: { xs: '68px', sm: '85px', md: '100px' },
                        }}
                      >
                        <Image
                          src={ad.image}
                          alt={'products'}
                          duration={500}
                          style={{ borderRadius: '10px' }}
                          showLoading={
                            <Skeleton
                              variant="rectangular"
                              width={'100%'}
                              sx={{
                                height: { xs: '68px', sm: '85px', md: '100px' },
                              }}
                            />
                          }
                        />
                      </Box>
                      <Box marginLeft={'10px'}>
                        <Typography variant="h5">{ad.name}</Typography>
                        <Typography variant="h6">
                          {ad.price > 0
                            ? `Rp ${toCurrencyForm(ad.price)}`
                            : 'FREE'}
                        </Typography>
                      </Box>
                    </Box>
                    <Box display={'flex'} flex={1}>
                      {ad.sizeOpts?.length > 0 && (
                        <Box marginLeft={'24px'} width={'85%'}>
                          <FormTextField
                            index={1}
                            required
                            type={'select'}
                            label={'Size Option'}
                            selectOpts={ad.sizeOpts}
                            errorMessage={ad.selectedSize.errorMessage}
                            value={ad.selectedSize.value}
                            onChange={(e) =>
                              handleAddonSizeChange(idx, e.target.value)
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </Box>
                ))}
            </Box>
          )}

          {currentPage === 3 && (
            <DialogContentText>
              Is the data correct? Make sure the data you enter is correct. Your
              data will be reset after leaving this page.
            </DialogContentText>
          )}
        </DialogContent>

        <DialogActions>
          <Button autoFocus onClick={handleBack} disabled={checkUserStatusLoad}>
            {getButtonBackText()}
          </Button>
          <LoadingButton
            onClick={handleNext}
            autoFocus
            loading={checkUserStatusLoad}
          >
            {getButtonNextText()}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default DetailVirtualParticipants;
